import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import createLogger from 'vuex/dist/logger'
import mutations from './mutation'
// 引入模块
import workOrder from './modules/work-order'

Vue.use(Vuex) // https://vuex.vuejs.org/en/

const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  state: {
    jurisdiction: []
  },
  mutations,
  actions,
  modules: {
    workOrder
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
